<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iv"></a>
<div class="img_containert">
<img alt="images" src="images/copy.jpg"/>
</div>
<p class="copy"><em class="italic">The Sinking of the Blücher</em></p>
<p class="copy">First published in 2023 by</p>
<p class="copy">Greenhill Books,</p>
<p class="copy">c/o Pen &amp; Sword Books Ltd,</p>
<p class="copy">47 Church Street, Barnsley,</p>
<p class="copy">S. Yorkshire, S70 2AS</p>
<p class="copy1"><span class="weblink"><a href="http://www.greenhillbooks.com" target="_blank"><span class="underline">www.greenhillbooks.com</span></a></span></p>
<p class="copy"><span class="weblink"><a href="mailto:contact@greenhillbooks.com"><span class="underline">contact@greenhillbooks.com</span></a></span></p>
<p class="copy1">ISBN: 978-1-78438-875-1</p>
<p class="copy">Epub ISBN 978-1-78438-875-1</p>
<p class="copy">Mobi ISBN 978-1-78438-875-1</p>
<p class="copy1">All rights reserved.</p>
<p class="copy1">© Geirr Haarr and Tor Jørgen Melien, 2023</p>
<p class="copy1">The rights of Geirr Haarr and Tor Jørgen Melien to be identified as authors of this work have been asserted in accordance with Section 77 of the Copyrights, Designs and Patents Act 1988.</p>
<p class="copy1">CIP data records for this title are available from the British Library</p>
<p class="copy1">Edited and designed by Donald Sommerville</p>
<p class="copy">Typeset in 11/13.5 pt Arno Pro Small Text and Arno Pro Display</p>
<p class="copy">Maps by Peter Wilkinson</p>
<p class="copy2"><em class="italic"><a href="#/xhtml/01_Halftitle#pgiimg1">Page i</a>:</em> The present-day Oscarsborg Fortress, now a museum commemorating the events of April 1940.</p>
<p class="copy"><em class="italic"><a href="#/xhtml/02_Dedication#pgiiimg1">Page ii</a>:</em> Oberst Eriksen.</p>
<p class="copy"><em class="italic"><a href="#/xhtml/03_Title#pgiiiimg1">Page iii</a>: Blücher</em> immediately before the start of the Norwegian campaign.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?bcc02e5c